import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getAllProgramsCountOrganizeWithoutCondition = (status, classtype, filters) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ORGANIZE.GET_ALL_PROGRAMS_COUNT_ORGANIZE_WITHOUTCONDITION(
      status,
      classtype,
      filters
    )
  );
};

export default getAllProgramsCountOrganizeWithoutCondition;
